import { i18n } from '@lingui/core';
import { de, en, es, fr, it, pt, sk } from 'make-plural/plurals';

i18n.loadLocaleData('de', { plurals: de });
i18n.loadLocaleData('en', { plurals: en });
i18n.loadLocaleData('es', { plurals: es });
i18n.loadLocaleData('fr', { plurals: fr });
i18n.loadLocaleData('it', { plurals: it });
i18n.loadLocaleData('pt', { plurals: pt });
i18n.loadLocaleData('sk', { plurals: sk });

/**
 * @param {keyof typeof messages} locale
 */
export default function activateLocale(locale, messages) {
  if (!messages[locale]) {
    console.error(`Unknown locale ${locale}`);
    return activateLocale('en');
  }

  i18n.load(locale, messages[locale]);
  i18n.activate(locale);
}
